(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spec-table"] && !Shopify.designMode) return;
  try {
    (function(){
  function initSpecWidget(root){
    var DATA = JSON.parse(root.dataset.specs);
    if (!DATA || !DATA.models || !DATA.specs) return;
    var models = DATA.models, specs = DATA.specs;
    var unit = 'in';
    var highlightDiffs = false;
    var mobileIndex = 0;
    var viewMode = 'single';
    var focusIndex = 0;
    var openGroup = true;

    var FRACTIONS = {'\u00BD':0.5,'\u00BC':0.25,'\u00BE':0.75};
    function parseNum(tok){
      var s = String(tok).trim();
      for (var f in FRACTIONS){
        if (s.indexOf(f) !== -1){
          var whole = s.replace(f,'').trim();
          var wn = whole === '' ? 0 : parseFloat(whole);
          if (isNaN(wn)) return null;
          return wn + FRACTIONS[f];
        }
      }
      if (/^\d+,\d+$/.test(s)) return parseFloat(s.replace(',', '.'));
      if (/^\d*\.?\d+$/.test(s)) return parseFloat(s);
      return null;
    }
    function parseRange(value){
      if (value == null) return null;
      var raw = String(value).trim();
      var m = raw.match(/^([0-9.,\u00BD\u00BC\u00BE]+)\s*[-\u2013]\s*([0-9.,\u00BD\u00BC\u00BE]+)$/);
      if (!m) return null;
      var a = parseNum(m[1]), b = parseNum(m[2]);
      if (a == null || b == null) return null;
      return [Math.min(a,b), Math.max(a,b)];
    }
    function convert(specLabel, value){
      if (unit !== 'cm') return value;
      if (!specLabel || !/\(inch\)/i.test(specLabel)) return value;
      if (value == null) return value;
      var raw = String(value).trim();
      if (raw === '' || raw === '-' || raw.toLowerCase() === 'n/a') return value;
      var range = parseRange(raw);
      if (range) return (range[0]*2.54).toFixed(1) + '\u2013' + (range[1]*2.54).toFixed(1) + ' cm';
      var single = parseNum(raw);
      if (single == null) return value;
      return (single*2.54).toFixed(1) + ' cm';
    }
    function rowHasDiff(values){
      var present = models.map(function(m){ return values[m]; }).filter(function(v){ return v != null; });
      if (present.length <= 1) return false;
      return !present.every(function(v){ return v === present[0]; });
    }
    function fitCandidates(){
      return specs.filter(function(row){
        return /\(inch\)/i.test(row.spec) && models.some(function(m){ return parseRange(row.values[m]) !== null; });
      });
    }
    function fitMatches(spec, measurementIn){
      return models.map(function(m){
        var r = parseRange(spec.values[m]);
        if (!r) return false;
        return measurementIn >= r[0] && measurementIn <= r[1];
      });
    }
    function biggestDiff(){
      var best = null;
      specs.forEach(function(row){
        var vals = models.map(function(m){ return row.values[m]; });
        var parsed = vals.map(function(v){ return v == null ? null : parseNum(String(v).trim()); });
        if (parsed.some(function(p){ return p == null; })) return;
        var lo = Math.min.apply(null, parsed), hi = Math.max.apply(null, parsed);
        if (lo <= 0) return;
        var pct = (hi - lo) / lo;
        if (!best || pct > best.pct){
          best = { row: row, lo: lo, hi: hi, pct: pct, loModel: models[parsed.indexOf(lo)], hiModel: models[parsed.indexOf(hi)] };
        }
      });
      return best;
    }

    var currentFitMatches = models.map(function(){ return false; });
    var unitLabelEl = null;

    function render(){
      root.querySelector('.sw-title').textContent = DATA.productName;
      root.querySelectorAll('.sw-unit-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.unit === unit); });

      root.querySelectorAll('.sw-mode-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.mode === viewMode); });
      root.querySelector('.sw-panel-single').style.display = viewMode === 'single' ? 'block' : 'none';
      root.querySelector('.sw-panel-compare').style.display = viewMode === 'compare' ? 'block' : 'none';

      var focusModel = models[Math.min(focusIndex, models.length - 1)];
      var singleTabs = root.querySelector('.sw-single-tabs');
      singleTabs.innerHTML = models.map(function(m, i){
        return '<button class="' + (i === focusIndex ? 'active' : '') + '" data-i="' + i + '">' + m + '</button>';
      }).join('');
      singleTabs.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){ focusIndex = parseInt(btn.dataset.i, 10); render(); });
      });

      var priorityEl = root.querySelector('.sw-priority');
      priorityEl.innerHTML = specs.slice(0, 4).map(function(row){
        var v = convert(row.spec, row.values[focusModel]);
        return '<div class="sw-priority-cell"><p class="sw-p-label">' + row.spec + '</p><p class="sw-p-value">' + (v == null ? '\u2014' : v) + '</p></div>';
      }).join('');

      var accEl = root.querySelector('.sw-accordion');
      var restSpecs = specs.slice(4);
      accEl.innerHTML = '<div class="sw-accordion-group"><button class="sw-accordion-head">All Specifications<span class="sw-accordion-chevron">' + (openGroup ? '\u2212' : '+') + '</span></button><div class="sw-accordion-body" style="display:' + (openGroup ? 'block' : 'none') + ';">' +
        restSpecs.map(function(row){
          var v = convert(row.spec, row.values[focusModel]);
          return '<div class="sw-accordion-row"><span style="color:#6B7280">' + row.spec + '</span><span>' + (v == null ? '\u2014' : v) + '</span></div>';
        }).join('') + '</div></div>';
      accEl.querySelector('.sw-accordion-head').addEventListener('click', function(){ openGroup = !openGroup; render(); });

      var diff = biggestDiff();
      var diffEl = root.querySelector('.sw-diff');
      if (diff){
        diffEl.style.display = 'block';
        diffEl.innerHTML = 'Biggest difference between sizes: <strong>' + diff.row.spec + '</strong> \u2014 ' +
          convert(diff.row.spec, String(diff.lo)) + ' (' + diff.loModel + ') to ' + convert(diff.row.spec, String(diff.hi)) + ' (' + diff.hiModel + ').';
      } else { diffEl.style.display = 'none'; }

      var thead = root.querySelector('.sw-thead-row');
      thead.innerHTML = '<th></th>' + models.map(function(m, i){
        return '<th class="' + (currentFitMatches[i] ? 'sw-fit-match' : '') + '">' + m + '</th>';
      }).join('');

      var tbody = root.querySelector('.sw-tbody');
      tbody.innerHTML = specs.map(function(row){
        var diffClass = highlightDiffs && rowHasDiff(row.values) ? 'sw-row-diff' : '';
        var cells = models.map(function(m, i){
          var v = convert(row.spec, row.values[m]);
          return '<td class="' + (currentFitMatches[i] ? 'sw-fit-match' : '') + '">' + (v == null ? '\u2014' : v) + '</td>';
        }).join('');
        return '<tr class="' + diffClass + '">' + '<td>' + row.spec + '</td>' + cells + '</tr>';
      }).join('');

      var tabs = root.querySelector('.sw-tabs');
      tabs.innerHTML = models.map(function(m, i){
        return '<button class="' + (i === mobileIndex ? 'active' : '') + '" data-i="' + i + '">' + (currentFitMatches[i] ? '\u25CF ' : '') + m + '</button>';
      }).join('');
      tabs.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){ mobileIndex = parseInt(btn.dataset.i, 10); render(); });
      });

      var mCards = root.querySelector('.sw-mobile-cards');
      var activeModel = models[Math.min(mobileIndex, models.length - 1)];
      mCards.innerHTML = specs.map(function(row){
        var v = convert(row.spec, row.values[activeModel]);
        var diffStyle = highlightDiffs && rowHasDiff(row.values) ? 'background:#FEFCE8;' : '';
        return '<div class="sw-mobile-row" style="' + diffStyle + '"><span style="color:#6B7280">' + row.spec + '</span><strong>' + (v == null ? '\u2014' : v) + '</strong></div>';
      }).join('');
    }

    var candidates = fitCandidates();
    if (candidates.length > 0){
      var fitBox = root.querySelector('.sw-fit');
      fitBox.style.display = 'block';
      var selectHtml = '';
      if (candidates.length > 1){
        selectHtml = '<select class="sw-fit-select">' + candidates.map(function(c){ return '<option value="' + c.spec + '">' + c.spec + '</option>'; }).join('') + '</select><br><br>';
      }
      fitBox.innerHTML = '<label>Find your fit</label>' + selectHtml +
        '<input type="number" class="sw-fit-input" placeholder="e.g. 20" style="width:90px;margin-right:8px;"> <span class="sw-fit-unit-label">inches</span>' +
        '<div class="sw-fit-result" style="margin-top:8px;"></div>' +
        '<p style="margin:6px 0 0;font-size:11px;color:#9CA3AF;">Measured against: <span class="sw-fit-spec-name"></span></p>';
      unitLabelEl = fitBox.querySelector('.sw-fit-unit-label');

      function activeFitSpec(){
        var sel = fitBox.querySelector('.sw-fit-select');
        var name = sel ? sel.value : candidates[0].spec;
        return specs.filter(function(s){ return s.spec === name; })[0] || candidates[0];
      }
      function updateFit(){
        var spec = activeFitSpec();
        fitBox.querySelector('.sw-fit-spec-name').textContent = spec.spec;
        var input = fitBox.querySelector('.sw-fit-input');
        var raw = input.value;
        var resultEl = fitBox.querySelector('.sw-fit-result');
        if (raw.trim() === '' || isNaN(parseFloat(raw))){
          currentFitMatches = models.map(function(){ return false; });
          resultEl.innerHTML = '';
          render();
          return;
        }
        var val = parseFloat(raw);
        var valIn = unit === 'cm' ? val / 2.54 : val;
        currentFitMatches = fitMatches(spec, valIn);
        if (currentFitMatches.some(Boolean)){
          resultEl.innerHTML = models.map(function(m, i){
            return currentFitMatches[i] ? '<span class="sw-badge sw-badge-green">' + m + ' fits</span>' : '';
          }).join('');
        } else {
          resultEl.innerHTML = '<span class="sw-badge sw-badge-yellow">No size in this range</span>';
        }
        render();
      }
      fitBox.querySelector('.sw-fit-input').addEventListener('input', updateFit);
      if (fitBox.querySelector('.sw-fit-select')){
        fitBox.querySelector('.sw-fit-select').addEventListener('change', updateFit);
      }
    }

    root.querySelectorAll('.sw-unit-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        unit = btn.dataset.unit;
        if (unitLabelEl) unitLabelEl.textContent = unit === 'in' ? 'inches' : 'centimeters';
        render();
      });
    });
    root.querySelectorAll('.sw-mode-btn').forEach(function(btn){
      btn.addEventListener('click', function(){ viewMode = btn.dataset.mode; render(); });
    });
    root.querySelector('.sw-diff-check').addEventListener('change', function(e){
      highlightDiffs = e.target.checked;
      render();
    });
    root.querySelector('.sw-print-btn').addEventListener('click', function(){
      var w = window.open('', '_blank', 'width=900,height=700');
      if (!w){ alert('Please allow pop-ups to print.'); return; }
      var rows = specs.map(function(row){
        return '<tr><th>' + row.spec + '</th>' + models.map(function(m){ return '<td>' + (convert(row.spec, row.values[m]) || '\u2014') + '</td>'; }).join('') + '</tr>';
      }).join('');
      var html = '<html><head><meta charset="UTF-8"><title>' + DATA.productName + '</title>' +
        '<style>body{font-family:Arial,sans-serif;margin:32px;}table{border-collapse:collapse;width:100%;}th,td{border:1px solid #ccc;padding:6px 10px;text-align:left;font-size:12.5px;}</style></head><body>' +
        '<h1>' + DATA.productName + '</h1><table><thead><tr><th></th>' + models.map(function(m){ return '<th>'+m+'</th>'; }).join('') + '</tr></thead><tbody>' + rows + '</tbody></table></body></html>';
      w.document.write(html);
      w.document.close();
      w.onload = function(){ w.focus(); w.print(); };
    });

    render();
  }

  function scan(){
    document.querySelectorAll('.spec-widget:not([data-sw-initialized])').forEach(function(root){
      root.setAttribute('data-sw-initialized', 'true');
      initSpecWidget(root);
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function(){ scan(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
